// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"245":"notfound","486":"orders","800":"outlets","876":"billing","966":"dashboard","983":"report"}[chunkId] + "." + {"245":"ded1b669","486":"4769b1f0","800":"ed11c330","876":"ed11c330","966":"90957cec","983":"55559daa"}[chunkId] + ".chunk.css";
};